export default __webpack_public_path__ + "d27745d26019885e183b06be076c750a.jpg";